// extracted by mini-css-extract-plugin
export default {"notification-wrapper":"Notification_notification-wrapper__cDhJ+","translateTop":"Notification_translateTop__Nfe-p","content":"Notification_content__ckw7Q"};